/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".footer[_ngcontent-%COMP%]{position:absolute;bottom:0;width:100%;height:70px;background-color:blue;text-align:center;color:#fff}.message[_ngcontent-%COMP%]{border-radius:50px;margin:0 15px 10px;padding:15px 20px;position:relative;font-weight:700}.message.to[_ngcontent-%COMP%]{background-color:#2095fe;color:#fff;margin-left:100px;text-align:right}.message.from[_ngcontent-%COMP%]{background-color:#e5e4e9;color:#363636;margin-right:100px}.message.from[_ngcontent-%COMP%] + .message.from[_ngcontent-%COMP%], .message.to[_ngcontent-%COMP%] + .message.to[_ngcontent-%COMP%]{margin-top:-10px}"];
export { styles as styles };

